import { render, staticRenderFns } from "./ApplicationsStatCard.vue?vue&type=template&id=2404d1ec&scoped=true&"
import script from "./ApplicationsStatCard.vue?vue&type=script&lang=js&"
export * from "./ApplicationsStatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2404d1ec",
  null
  
)

export default component.exports